var map = {
	"./Albanianflag.png": 92825,
	"./Croatianflag.png": 33376,
	"./Czechflag.png": 42258,
	"./Dutchflag.png": 44749,
	"./Estonianflag.png": 66626,
	"./Frenchflag.png": 43887,
	"./Germanflag.png": 21141,
	"./Hindiflag.png": 81471,
	"./Hungarianflag.png": 68116,
	"./Indonesianflag.png": 24803,
	"./Italianflag.png": 92799,
	"./Lithuanianflag.png": 23054,
	"./Polishflag.png": 3168,
	"./Portugueseflag.png": 92740,
	"./Slovakflag.png": 75813,
	"./Spanishflag.png": 87311,
	"./Swedishflag.png": 86360,
	"./Turkishflag.png": 11455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6627;